import _ from 'lodash';
import { ADMIN, GUEST } from 'sources/constants/userRoles';

const routesRegistry = {
  [ADMIN]: '/admin/users',
};

export default class Role {
  constructor(role) {
    this.role = role;
  }

  isGuest() {
    return this.role === GUEST;
  }

  isAdmin() {
    return this.role === ADMIN;
  }

  isHasRole(role) {
    return this.role === role;
  }

  getAfterLoginPath() {
    return routesRegistry[this.role] || '/';
  }
}

export function createRole(user) {
  const role = _.get(user, 'role', null);

  if (!role) {
    return new Role(GUEST);
  }

  return new Role(role);
}



// WEBPACK FOOTER //
// ./src/components/helpers/Role.js